import axios from 'axios';
import Common from '../componets/Common';

export const obtenerPago = async (invoice, authPayment) => {
  const url = `${Common.urlAPI}/payment/${invoice}`
  const resPaymentGet = await axios.get( url, authPayment)
            .catch((error) => {
              if (error.response && error.response.status === 401) {
                alert("El token es invalido para este usuario");
              }else{
                return{
                  data: {
                    status:"NOK",
                    message: error.toString()
                  }
                }
              }
            });

  return resPaymentGet;
}
